import {
  GET_PERMISSIONS,
  PERMISSION_FAIL,
  RESET_PERMISSIONS,
  GET_PERMISSIONS_FLAG,
  GET_TP_LEADS_LOADING,
  GET_TP_LEADS,
  GET_TP_LEADS_ERROR,
} from "../type/type";
import navigation from "../../config/navConfig";

const initialState = {
  allowedRoutesLoading: true,
  allowedRoutes: [],
  isSuperAdmin: false,
  permissionsFlag: [],
  permissionFlagsLoading: true,
  allLeadsData: {
    docs: [],
    totalDocs: 0,
    limit: 0,
    page: 0,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  allLeadsLoading: true,
  loading: false,
};

const adminReducers = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_PERMISSIONS:
      const { permissions, userType } = payload;
      const filteredNav = navigation.items
        .map((nav) => {
          if (nav.superAdminOnly && userType !== "SUPER") {
            return null;
          }

          if (nav.children && nav.children.length > 0) {
            const filteredChildren = nav.children.filter((child) => {
              if (child.superAdminOnly && userType !== "SUPER") {
                return false;
              }
              if (userType === "SUPER") {
                return true;
              }
              return Array.isArray(permissions) && permissions.includes(child.key);
            });

            if (filteredChildren.length > 0) {
              return {
                ...nav,
                children: filteredChildren,
              };
            }
            return null;
          }

          if (
            userType === "SUPER" ||
            (Array.isArray(permissions) && permissions.includes(nav.key)) ||
            nav.key === "DASHBOARD" ||
            nav.key === "PROTECTED"
          ) {
            return { ...nav };
          }

          return null;
        })
        .filter(Boolean);

      return {
        ...state,
        allowedRoutesLoading: false,
        allowedRoutes: filteredNav,
      };
    case PERMISSION_FAIL:
      return { ...state, allowedRoutesLoading: false, allowedRoutes: [] };
    case RESET_PERMISSIONS:
      return { ...initialState };
    case GET_PERMISSIONS_FLAG:
      return {
        ...state,
        permissionFlagsLoading: false,
        permissionsFlag: payload,
      };
    case GET_TP_LEADS_LOADING:
      return { ...state, loading: true };
    case GET_TP_LEADS:
      return {
        ...state,
        allLeadsData: {
          ...state.allLeadsData, // Keep existing structure
          ...payload, // Update with new API response data
          page: payload.page || state.allLeadsData.page, // Ensure the page updates correctly
        },
        allLeadsLoading: false,
        loading: false,
      };
    case GET_TP_LEADS_ERROR:
      return {
        ...state,
        loading: false,
        allLeadsLoading: false,
      };
    default:
      return state;
  }
};
export default adminReducers;
